<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <b-row>
          <b-col md="6">
            <b-media no-body>
              <b-media-aside
                class="mr-2"
              >
                <b-avatar
                  size="48"
                  variant="light-info"
                >
                  <feather-icon
                    size="24"
                    icon="BoxIcon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ itemData.suppliers }}
                </h4>
                <b-card-text class="font-small-3 mb-0">
                  Tedarikçi Teklifi
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <purchase-offer-lines-odate />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <purchase-offer-lines-price />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BCardText,
} from 'bootstrap-vue'
import PurchaseOfferLinesOdate from '@/views/Admin/Purchase_offers/Elements/Lines/OfferDateCard.vue'
import PurchaseOfferLinesPrice from '@/views/Admin/Purchase_offers/Elements/Lines/PriceCard.vue'

export default {
  name: 'PurchaseOfferLinesItemForm',
  components: {
    PurchaseOfferLinesPrice,
    PurchaseOfferLinesOdate,
    BRow,
    BCol,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BCardText,
  },
  computed: {
    itemData() {
      return this.$store.getters['purchaseOfferLines/dataItem']
    },
  },
}
</script>
